import * as React from 'react';
import { useAsyncFn } from 'react-use';

import { useTranslation } from '@wearehelpful/ui-localization';
import { compiler } from 'markdown-to-jsx';
import {
  Button,
  Content,
  Footer,
  Header,
  Page,
  Typography,
} from '@wearehelpful/ui-kit';
import { CDTO } from '@helpful/network';

import { templateContent } from '../Bootstrap/Bootstrap';

import { Body, Image, Placeholder } from './SuccessScreen.style';

interface SuccessScreenProps extends Pick<CDTO.Success, 'title' | 'body'> {
  image?: { url: string };
  bodyTemplateVariables?: object;
  defaultHref: string;
  onCtaClick: () => void;
  ctaLabel?: string;
  closable?: boolean;
  onCloseClick?: () => void;
}

export const SuccessScreen: React.FC<SuccessScreenProps> = ({
  title,
  body = '',
  image,
  bodyTemplateVariables,
  defaultHref,
  onCtaClick,
  ctaLabel,
  closable = true,
  onCloseClick,
}) => {
  const { t } = useTranslation();

  const [{ loading }] = useAsyncFn(async () => onCtaClick());

  return (
    <Page>
      <Header>
        {closable && (
          <Header.Actions>
            <Header.Close onClick={onCloseClick} defaultHref={defaultHref} />
          </Header.Actions>
        )}
      </Header>
      <Content padding>
        <Content.Subheader>
          <Typography variant="h2" align="center">
            {title}
          </Typography>
        </Content.Subheader>
        <Content.Fixed inset>
          <Body>
            {compiler(templateContent(body, bodyTemplateVariables), {
              wrapper: null,
            })}
          </Body>
          {image && (
            <Placeholder>
              <Image src={image?.url} alt="" />
            </Placeholder>
          )}
        </Content.Fixed>
      </Content>
      <Footer>
        <Button loading={loading} onClick={onCtaClick}>
          {ctaLabel || t('actions.done')}
        </Button>
      </Footer>
    </Page>
  );
};
